export default __webpack_public_path__ + "static/media/goblin2.f91699a3.png";